import React, { PropsWithChildren } from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import styles from './PageHeader.scss';

export type PageHeaderProps = {
  className?: ClassNameType;
  strap?: string;
  title?: string;
}

const PageHeader: React.FC<PropsWithChildren<PageHeaderProps>> = ({
  children,
  className,
  strap,
  title,
}) => (
  <div className={cx(styles.component, className)}>
    <div className={styles.content}>
      {title ? <h1 className={cx(styles.title, { [styles.noStrap]: !strap })}>{title}</h1> : null}
      {strap ? <p>{strap}</p> : null}
      {children}
    </div>
  </div>
);

export default PageHeader;
